import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CustomModalService {
    private modals: any[] = [];

    add(modal: any) {
        this.modals.push(modal);
    }

    remove(id: string) {
        this.modals = this.modals.filter(modal => modal.id !== id);
    }

    open(id: string) {
        const modal = this.modals.find(modal => modal.id === id);
        modal.open(modal);
    }

    close(id: string) {
        const modal = this.modals.find(modal => modal.id === id);
        modal.close();
    }
}